import { Route } from "@angular/router";
import { LayoutComponent } from "@app/core/layout/layout.component";
import { initialDataResolver } from "./app.resolvers";
import { AuthGuard } from "./core/auth/auth.guard";

export const appRoutes: Route[] = [
    // Login (empty layout)
    {
        path: "login",
        component: LayoutComponent,
        canActivate: [AuthGuard],
        data: { layout: "empty" },
        loadChildren: () =>
            import("./features/login/login.routes").then((m) => m.loginRoutes)
    },

    // Authenticated area (classic layout)
    {
        path: "",
        component: LayoutComponent,
        canActivate: [AuthGuard],
        resolve: { initialData: initialDataResolver },
        data: { layout: "classic" },
        children: [
            {
                path: "dashboard",
                loadChildren: () =>
                    import("./features/dashboard/dashboard.routes").then(
                        (m) => m.dashboardRoutes
                    )
            },
            {
                path: "",
                redirectTo: "dashboard",
                pathMatch: "full"
            }
        ]
    },

    // Fallback
    { path: "**", redirectTo: "dashboard" }
];
